<beslutningliste-kompakt [beslutninger]="beslutninger()"/>
